// JsFromRoutes CacheKey 346aeed7065291356c70c0666bfcaf85
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/order/confirmation/:order_number/:buyer_token/contacts'),
  update: /* #__PURE__ */ definePathHelper('patch', '/order/confirmation/:order_number/:buyer_token/contacts/:id'),
}
